import React from "react";
import duration from "../Assets/Images/duration.png";
import calendar from "../Assets/Images/calendar.png";
import returns from "../Assets/Images/returns.png";
import profit from "../Assets/Images/profit.png";
import { timeformatter } from "../utils/dateformatter";
import { formatAmount } from "../utils/formatAmount";
import { CiMemoPad } from "react-icons/ci";

const RealEstateCta = ({ openModal, state }) => {
  return (
    <div>
      <div className="shadow-md mt-6 p-6 w-full lg:w-[522px] h-[270px] rounded-[14px] border-[1px] border-[#F0F0F5] flex justify-between flex-col">
        <div>
          <div className="text-[32px] text-[#131e3d] font-[500]">
            {state?.currency === "USD" ? "$" : "₦"}
            {formatAmount(state?.total_units * state?.amount_per_unit)}
          </div>
          <div className="text-[14px] font-[400] text-[#131e3d]">
            {state?.currency === "USD" ? "$" : "₦"}
            {formatAmount(state?.amount_per_unit)} per unit
          </div>
        </div>
        <div className="flex gap-[10px] items-center">
          {state?.campaign_due_date ? (
            <div className="  gap-[5px] flex items-center">
              <img src={duration} alt="" className=" w-[14px] h-[14px] " />
              <div className="text-[12px] font-[400] text-[#9C9C9E]">
                Campaign Due{" "}
                {state?.campaign_due_date
                  ? timeformatter(
                      state?.campaign_due_date,
                      "formal",
                      false,
                      true
                    )
                  : "-"}
              </div>
            </div>
          ) : (
            <></>
          )}

          {state?.property_appreciation ? (
            <div className="flex gap-[5px] items-center">
              <img src={calendar} alt="" className=" w-[14px] h-[14px] " />
              <div className="text-[12px] font-[400] text-[#9C9C9E]">
                {`${state?.property_appreciation} year${
                  Number(state?.property_appreciation) === 1 ? "" : "s"
                }`}{" "}
                Tenure
              </div>
            </div>
          ) : (
            <></>
          )}

          {state?.annual_roi ? (
            <div className="flex gap-[5px] items-center">
              <img src={returns} alt="" className=" w-[14px] h-[14px] " />
              <div className="text-[12px] font-[400] text-[#20A43D]">
                {Number(state?.annual_roi)}% Net Return
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {state?.payout_type ? (
          <div className="flex gap-[5px] items-center mt-2">
            <img src={profit} alt="" className="w-[14px] h-[14px] " />
            <div className="text-[12px] capitalize font-[400] text-[#9C9C9E]">
              {state?.payout_type}
            </div>
          </div>
        ) : (
          <></>
        )}

        {state?.status == 9 ? (
          <></>
        ) : (
          <div>
            <div className="text-[14px] font-[400] text-[#131e3d]">
              {state?.total_units
                ? (
                    (state?.total_amount_invested /
                      (state?.total_units * state?.amount_per_unit)) *
                    100
                  ).toFixed(1)
                : "-"}
              % invested of target
            </div>
            <div className="w-full overflow-hidden rounded-full mt-[10px] bg-[#F2F2F7] h-[4px]">
              <div
                className="bg-[#6935D3] h-[4px]"
                style={{
                  width: `${
                    (state?.total_amount_invested /
                      (state?.total_units * state?.amount_per_unit)) *
                    100
                  }%`,
                }}
              ></div>
            </div>
          </div>
        )}
        <div className="flex justify-between items-center flex-wrap">
          <button
            className={`bg-[#6935D3] px-8  h-[45px] rounded-[8px] text-white font-[500] text-[16px] ${
              state?.status == 1 || state?.status == 9
                ? ""
                : "opacity-60 !cursor-not-allowed"
            }`}
            onClick={
              state?.status == 1 || state?.status == 9 ? openModal : () => {}
            }
          >
            {state?.status == 9 ? "Book Slot" : "Start Investing"}
          </button>

          <div
            className={`flex gap-[5px]  items-center ${
              state?.properties_documents[0]
                ? "cursor-pointer"
                : "cursor-not-allowed opacity-[0.7]"
            }`}
          >
            <CiMemoPad className="text-[#6935D3] " />
            <a
              rel="noreferrer"
              href={
                state?.properties_documents[0]
                  ? state?.properties_documents[0]
                  : null
              }
              download={`${state?.name} Documents`}
              target="_blank"
            >
              <div className={`text-[14px] font-[400] text-[#6935D3] `}>
                Read Memo
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateCta;
